import React from 'react';
import { Alert, Button, CircularProgress, LinearProgress } from '@mui/material';
import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
import studyPlannerImage from '../../assets/images/ielts-study-planner-transparent.png';
import useIeltsPlanner from './useIeltsPlanner';

export default function IeltsPlannerCard() {
  const { data, loading, error, refresh } = useIeltsPlanner();
  const tasks = (data?.tasks || []).filter((task) => task.date === data.today);
  const planned = tasks.filter((task) => task.status !== 'skipped');
  const completed = planned.filter((task) => task.status === 'completed').length;
  const ready = data?.enabled && data.plan && !data.needsSetup;
  const paused = data?.plan?.status === 'paused';
  return (
    <section className="ielts-overview-planner" aria-labelledby="ielts-planner-heading">
      <div className="ielts-overview-planner-top"><EventNoteOutlinedIcon />
        {data?.enabled && <span className="ielts-overview-planned">{data.tier === 'adaptive' ? 'Adaptive' : 'Basic'}</span>}
      </div>
      <h2 id="ielts-planner-heading">AI Study Planner</h2>
      <img className={`ielts-overview-planner-image${ready ? ' ielts-overview-planner-image-compact' : ''}`} src={studyPlannerImage} width="480" height="320" alt="" />
      {loading && !data && <CircularProgress size={22} aria-label="Loading study planner" />}
      {error ? <Alert severity="warning" action={<Button onClick={refresh} disabled={loading}>Retry</Button>}>{error}</Alert>
        : data?.enabled ? <>
          <p>{!data.plan || data.needsSetup ? 'Your study plan is ready to set up.'
            : data.plan.status === 'paused' ? 'Your plan is paused.'
              : planned.length ? `${completed} of ${planned.length} tasks completed today` : 'No tasks scheduled for today.'}</p>
          {ready && !paused && planned.length > 0 && <div className="ielts-overview-planner-today">
            <LinearProgress variant="determinate" value={completed / planned.length * 100} aria-label="Today's study progress" />
            <p>{planned.reduce((total, task) => total + task.minutes, 0)} min planned</p>
            <ul>{planned.slice(0, 3).map((task) => <li key={task.id}>
              <span><strong>{task.title}</strong><small>{task.skill} · {task.status === 'completed' ? 'Completed' : task.status === 'in_progress' ? 'In progress' : 'To do'}</small></span>
              <span className="ielts-overview-planner-minutes">{task.minutes} min</span>
            </li>)}</ul>
            {planned.length > 3 && <p>+{planned.length - 3} more in your plan</p>}
          </div>}
          <Button component={Link} to="/ielts/study-planner" endIcon={<ArrowForwardIcon />}>{!ready ? 'Set up your plan' : !paused && completed < planned.length ? 'Continue studying' : 'Open planner'}</Button>
        </> : data && <span className="ielts-overview-planner-note">Not available yet</span>}
    </section>
  );
}
